/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Finance_Packs_DetailInputs */

const en_features_finance_packs_detail = /** @type {(inputs: Features_Finance_Packs_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`this month`)
};

const pl_features_finance_packs_detail = /** @type {(inputs: Features_Finance_Packs_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`w tym miesiącu`)
};

/**
* | output |
* | --- |
* | "this month" |
*
* @param {Features_Finance_Packs_DetailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_finance_packs_detail = /** @type {((inputs?: Features_Finance_Packs_DetailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Finance_Packs_DetailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_finance_packs_detail(inputs)
	return en_features_finance_packs_detail(inputs)
});